const navMenuData = {
  brand: "القائمة",
  List: [
    {
      id: 1,
      name: "الرئيسية",
      path: "/",
    },
    {
      id: 2,
      name: "المسبحة",
      path: "/masbaha",
    },
    {
      id: 3,
      name: "فضل الذكر",
      path: "/fadle-elzikr",
    },
    {
      id: 4,
      name: "الأذكار المفضلة",
      path: "/favourite-azkar",
    },
    {
      id: 5,
      name: "جميع الأذكار",
      path: "/all-azkar",
    },
    {
      id: 6,
      name: "الأوراد",
      path: "/awrad",
    },
    {
      id: 7,
      name: "عنا",
      path: "/about-us",
    },
  ],
};

export default navMenuData;
